import type { Locale } from '@seek/melways-sites';
import { VocabProvider } from '@vocab/react';
import React, { type ReactNode } from 'react';

import {
  FEATURE_PSEUDO_LOCALISATION,
  useFeatureToggleData,
} from 'src/app/featureToggle';

interface ProviderProps {
  children: ReactNode;
  language: Locale | 'en-PSEUDO';
}

export const CustomVocabProvider = ({ children, language }: ProviderProps) => {
  const isPseudoL10nEnabled = useFeatureToggleData(FEATURE_PSEUDO_LOCALISATION);

  return (
    <VocabProvider language={isPseudoL10nEnabled ? 'en-PSEUDO' : language}>
      {children}
    </VocabProvider>
  );
};
